import React, { useEffect } from "react";
import { observer } from "mobx-react";

import Http from "services/Http";
import { MessageSummary } from "components/MessageSummary/MessageSummary";
import { ProgressSpinnerOverlay } from "components/ProgressSpinnerOverlay/ProgressSpinnerOverlay";

import { useNotificationsStore, GlobalNotificationTable } from ".";
import { NotificationPageViewModel } from "api";
import "./Notifications.scss";

export const NotificationsPage: React.FC<NotificationPageViewModel> = observer(
  function (props) {
    const { notificationGlobalStore, messageStore, ...store } =
      useNotificationsStore();

    const clearMessage = () => messageStore.clear();

    useEffect(() => {
      if (props.message) {
        messageStore.successMessage(props.message);
      }

      store.init();
    }, []);

    if (!store.initalized) return null;

    return (
      <div className="notifications">
        <ProgressSpinnerOverlay
          displayOverlay={Http.isFetchingData}
          waitMessage={Http.waitMessage}
        />
        <MessageSummary
          message={messageStore.message}
          onRemove={clearMessage}
        />
        <GlobalNotificationTable />
      </div>
    );
  }
);
